'use strict'

export default {
    // AccountInfo
    email: '^[a-zA-Z0-9_.+-]+[a-zA-Z0-9_-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9]+(\\.[a-zA-Z0-9]+)?$',
    password: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&])\\S{9,32}$',
    cellPhoneNumber: '^07[0-9]{3} [0-9]{3} [0-9]{3}$',
    employerPhoneNumber: '^0(1|2|3|7|8)[0-9]{9,13}$',

    // PersonalData
    name: '^$|^(?=.{1,50}$)[a-zA-Z]+([ \\-"\'][a-zA-Z]+|\\. ?[a-zA-Z]+)*$',
    surname: '^$|^(?=.{1,50}$)[a-zA-Z]+([ \\-"\'][a-zA-Z]+|\\. ?[a-zA-Z]+)*$',
    date: '^[0-9]{4}-[0-9]{2}-[0-9]{2}$',

    // Address
    county: "^[a-zA-Z0-9 \\-'./,]{0,50}$",
    city: "^[a-zA-Z0-9 \\-'./,]{1,40}$",
    street: "^[a-zA-Z0-9 \\-'./,]{1,37}$",
    streetNumber: "^$|^(?=.*\\d)[a-zA-Z0-9 \\-'./,]{1,12}$",
    flatNumber: "^[a-zA-Z0-9 \\-'./,]{0,50}$",
    houseName: "^$|^[a-zA-Z0-9 \\-'./,&]{1,50}$",
    peopleSplitRent: '^(0|[1-9][0-9]?)$',

    // Employer
    employer: /^[a-zA-Z0-9][a-zA-Z0-9 .,&\'’)(\-\/@:+!?*#]{1,160}[a-zA-Z0-9.]$/,
    dateOfDayPaid: '^(0?[1-9]|[12][0-9]|3[01])$',
    dependants: '^[0-9]$',
    income: '^(0|[1-9][0-9]{0,5})$', // 0| Must be for employmentCustom rule
    cost: '^(0|[1-9][0-9]{0,3})$',
    costEmpty: '^(|0|[1-9][0-9]{0,5})$',

    // Other
    notEmpty: '^.+$',
    notEmptyNumber: '^[0-9]+$',
    notEmptyNumberAndZero: '^[1-9][0-9]*$',
    notEmptyDecimalNumber: '^[0-9]+(\\.[0-9]+)?$',
    promoCode: '[0-9a-zA-Z]{4,}',
    oneNumber: '[0-9]{1}',
    sixNumbers: '[0-9]{6}',

    startWithLetter: '^[a-zA-Z]',
    endWithLetter: '[a-zA-Z]$',
    noConsecutiveCharacters: "[.\\-']{2}",
    noConsecutiveSpaces: '\\s{2,}',
    invalidCharacters: "[^a-zA-Z .'\\-]",
    mustNotExceed: '^.{1,50}$',
    noSpaceSurroundedSpecial: "\\s[\\-']|[\\-']\\s",
}
